export const cilChartline1 = [
  '40 40',
  `
<path d="M29.375 12.5V15H34.4822L19.6875 29.7948L14.0625 24.1698L5.99109 32.2411L7.7589 34.0089L14.0625 27.7052L19.6875 33.3302L36.25 16.7678V21.875H38.75V12.5H29.375Z" />
<path d="M3.75 8.125H1.25V38.75H38.75V36.25H3.75V8.125Z" />
`,
];
